import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PanelHostService, PanelType } from '../services/panel-host.service';

type PanelContextCheck = (panelHost: PanelHostService) => boolean;

/** Panels whose mobile route needs in-memory context to render (ADR-0017). */
const PANEL_CONTEXT_CHECKS: Partial<Record<Exclude<PanelType, null>, PanelContextCheck>> = {
  'edit-trip-event': panelHost => panelHost.tripEventPanelContext() !== null,
};

/**
 * Redirects a context-bearing panel's mobile route when its required context
 * is absent — a deep link, refresh, or native cold-restore has no in-memory
 * record to edit, so the page should never render a blank form for it.
 */
export function panelContextGuard(panel: Exclude<PanelType, null>, redirectTo: string): CanActivateFn {
  return () => {
    const panelHost = inject(PanelHostService);
    const router = inject(Router);

    const hasContext = PANEL_CONTEXT_CHECKS[panel];
    if (hasContext && !hasContext(panelHost)) {
      return router.createUrlTree([redirectTo]);
    }

    return true;
  };
}
